import React, { useState } from "react";
import { BellRing, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";

// Bulk nudge controls on the Bio List: select-all (members without a bio), nudge selected, nudge entire list.
export default function BioNudgeBar({ missingIds, selected, setSelected, groupName, subgroupId, onDone }) {
  const [busy, setBusy] = useState(null);
  const allChecked = missingIds.length > 0 && missingIds.every((id) => selected.has(id));
  const toggleAll = () => setSelected(allChecked ? new Set() : new Set(missingIds));

  const run = async (kind, req) => {
    setBusy(kind);
    try {
      const { data } = await req();
      toast.success(`Nudge sent to ${data.count} team member${data.count === 1 ? "" : "s"}`);
      setSelected(new Set()); onDone();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(null); }
  };
  const nudgeSelected = () => run("selected", () => api.post("/bios/nudge", { member_ids: [...selected] }));
  const nudgeAll = () => run("all", () => api.post("/bios/remind-missing", null, { params: subgroupId ? { subgroup_id: subgroupId } : {} }));

  if (!missingIds.length) return null;
  return (
    <div className="mb-3 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-slate-200 bg-white px-4 py-2.5" data-testid="bios-nudge-bar">
      <label className="flex cursor-pointer items-center gap-2.5 text-sm text-slate-600">
        <Checkbox checked={allChecked} onCheckedChange={toggleAll} data-testid="bios-select-all" />
        Select all without a bio ({missingIds.length})
      </label>
      <div className="flex flex-wrap items-center gap-2">
        <Button size="sm" variant="outline" className="rounded-full" disabled={!!busy || selected.size === 0} onClick={nudgeSelected} data-testid="bios-nudge-selected">
          {busy === "selected" ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <BellRing className="mr-1.5 h-3.5 w-3.5" />} Nudge selected ({selected.size})
        </Button>
        <Button size="sm" className="rounded-full bg-slate-900 hover:bg-slate-800" disabled={!!busy} onClick={nudgeAll} data-testid="bios-remind-all">
          {busy === "all" ? <Loader2 className="mr-1.5 h-3.5 w-3.5 animate-spin" /> : <BellRing className="mr-1.5 h-3.5 w-3.5" />} {groupName ? `Nudge everyone in ${groupName}` : "Nudge entire team"} ({missingIds.length})
        </Button>
      </div>
    </div>
  );
}
